// extracted by mini-css-extract-plugin
export var announcements = "announcements-module--announcements--JerBZ";